import {
    get,
    post
} from '../units/request'
let apiFun = [];
// let url = 'http://192.168.1.38:5159/api/modelSales/'
let url = 'http://49.232.163.2:5159/api/modelSales/'

apiFun.postLogin = p => post(url + 'Login/Login', p) //通过验证码登录
apiFun.postLoginPwd = p => post(url + 'Login/LoginPwd', p) //通过密码登录
apiFun.getSendCodeV3 = p => get(url + 'Login/SendCodeV3', p) //获取登录验证码
apiFun.getSendCodeV2 = p => get(url + 'Login/SendCodeV2', p) //获取注册验证码
apiFun.postUploadAvatar = p => post(url + 'Platform/UploadAvatar', p) //上传头像
apiFun.postRegistrationUser = p => post(url + 'Login/RegistrationUser', p) //注册
apiFun.getLogout = p => get(url + 'Platform/Logout', p) //退出登录
apiFun.postPwd = p => post(url + 'HomePage/Pwd', p) //是否设置过密码
apiFun.postNewPwd = p => post(url + 'HomePage/NewPwd', p) //设置新密码
apiFun.postEditPwd = p => post(url + 'HomePage/EditPwd', p) //修改密码
apiFun.getSendCodeV2s = p => get(url + 'SellerCenter/SendCodeV2s', p) //忘记密码获取验证码
apiFun.getverificationV3s = p => get(url + 'SellerCenter/verificationV3s', p) //忘记密码获取验证码

apiFun.getUserInt = p => get(url + 'Platform/UserInt', p) //查询用户信息
apiFun.postUploadFile = p => post(url + 'Platform/UploadFile', p) //上传图片
apiFun.postChunkUploadFile = p => post(url + 'Platform/UploadFiles', p) //分段上传
apiFun.getRecommendedPopular = p => get(url + 'HomePage/RecommendedPopular', p) //热门模型推荐
apiFun.getBuyerCenterMyInterest = p => get(url + 'BuyerCenter/MyInterest', p) //我的关注
apiFun.getHomePageSearch = p => get(url + 'HomePage/HomePageSearch', p) //搜索关键词
apiFun.getOneType = p => get(url + 'HomePage/OneType', p) //首页模型类型
apiFun.getFileDate = p => get(url + 'Platform/FileDate', p) //查看模型详情页
apiFun.getMyShoppingCart = p => get(url + 'BuyerCenter/MyShoppingCart', p) //查看购物车
apiFun.postDeleMyShoppingCart = p => post(url + 'BuyerCenter/DeleMyShoppingCart', p) //购物车删除商品
apiFun.getMyFootprints = p => get(url + 'BuyerCenter/MyFootprints', p) //查看我的足迹
apiFun.getFileDate = p => get(url + 'HomePage/FileDate', p) //查看模型详情页
apiFun.postAddMyShoppingCart = p => post(url + 'BuyerCenter/AddMyShoppingCart', p) //加入购物车
apiFun.getOrderVolume = p => get(url + 'HomePage/OrderVolume', p) //去付款
apiFun.getMyCollection = p => get(url + 'BuyerCenter/MyCollection', p) //我的收藏
apiFun.getAddMyCollection = p => get(url + 'BuyerCenter/AddMyCollection', p) //点击收藏按钮
apiFun.getAddMyInterest = p => get(url + 'BuyerCenter/AddMyInterest', p) //点击关注按钮
apiFun.getFormatRenderers = p => get(url + 'Platform/FormatRenderers', p) //文件格式
apiFun.getMyOrder = p => get(url + 'BuyerCenter/MyOrder', p) //我的订单
apiFun.getCancelMyOrder = p => get(url + 'BuyerCenter/CancelMyOrder', p) //取消订单
apiFun.getDelMyOrder = p => get(url + 'BuyerCenter/DelMyOrder', p) //删除订单
apiFun.getIncomeExpense = p => get(url + 'BuyerCenter/IncomeExpense', p) //资金明细
apiFun.postUploadFile = p => post(url + 'Platform/UploadFile', p) //上传模型
apiFun.getQueryCategory = p => get(url + 'Platform/QueryCategory', p) //发布页面类别查询
apiFun.postAddFileDate = p => post(url + 'Platform/AddFileDate', p) //模型发布按钮
apiFun.getPayment = p => get(url + 'BuyerCenter/Payment', p) //充值中心充值按钮
apiFun.getOrderSummary = p => get(url + 'SellerCenter/OrderSummary', p) //卖家中心-商户首页
apiFun.getOrderDetails = p => get(url + 'SellerCenter/OrderDetails', p) //卖家中心-商户首页-近30天销售
apiFun.getModelManagement = p => get(url + 'SellerCenter/ModelManagement', p) //卖家中心-模型管理
apiFun.getWithdrawRecord = p => get(url + 'SellerCenter/WithdrawRecord', p) //卖家中心-提现记录
apiFun.postWithdrawal = p => post(url + 'SellerCenter/Withdrawal', p) //卖家中心-设置提现账号
apiFun.postWithdrawalRequest = p => post(url + 'SellerCenter/WithdrawalRequest', p) //卖家中心-提现申请
apiFun.getDownloadFile = p => get(url + 'Platform/Download', p) //下载文件
apiFun.getPopularModelers = p => get(url + 'HomePage/PopularModelers', p) //推荐模型师
apiFun.getDesignerHomepage = p => get(url + 'HomePage/DesignerHomepage', p) //模型师主页
apiFun.getSearchType = p => get(url + 'HomePage/SearchType', p) //首页类型
apiFun.getSearchs = p => get(url + 'HomePage/Searchs', p) //首页搜索
apiFun.getBuyerUserHomepage = p => get(url + 'BuyerCenter/UserHomepage', p) //买家首页信息
apiFun.getSellerHomepage = p => get(url + 'SellerCenter/UserHomepage', p) //卖家首页信息
apiFun.getContentOverview = p => get(url + 'SellerCenter/ContentOverview', p) //卖家内容概况
apiFun.getTopUpCenter = p => get(url + 'BuyerCenter/TopUpCenter', p) //充值中心
apiFun.postBuyNows = p => post(url + 'Platform/BuyNows', p) //模型详情页-立即购买
// apiFun.postMerchantCA = p => post(url + 'SellerCenter/MerchantCA', p) //模型师认证
apiFun.postIdCardCheck = p => post(url + 'SellerCenter/IdCardCheck', p) //模型师认证
apiFun.getSeleMerchantCA = p => get(url + 'SellerCenter/SeleMerchantCA', p) //模型师认证
apiFun.getSeleWithdrawal = p => get(url + 'SellerCenter/SeleWithdrawal', p) //查询提现账号
apiFun.getModelRemove = p => get(url + 'SellerCenter/ModelRemove', p) //下架模型
apiFun.postPersonalnform = p => post(url + 'HomePage/Personalnform', p) //修改用户名
apiFun.getHomePageMyInterest = p => get(url + 'HomePage/MyInterest', p) //首页我的关注模型师
apiFun.postUploadReference = p => post(url + 'Platform/UploadReference', p) //联系我们上传参考文件
apiFun.postUploadProof = p => post(url + 'Platform/UploadProof', p) //举报模型上传举报材料
apiFun.postCustomize = p => post(url + 'HomePage/Customize', p) //提交定制需求
apiFun.postAccusation = p => post(url + 'HomePage/Accusation', p) //提交举报
apiFun.postInvoice = p => post(url + 'BuyerCenter/Invoice', p) //添加新的发票抬头
apiFun.getInvoiceOrder = p => get(url + 'BuyerCenter/InvoiceOrder', p) //查询选择开票订单
apiFun.getSeleInvoice = p => get(url + 'BuyerCenter/SeleInvoice', p) //查询发票抬头
apiFun.getInvoiceRecord = p => get(url + 'BuyerCenter/InvoiceRecord', p) //查询开票记录
apiFun.getDeInvoice = p => get(url + 'BuyerCenter/DeInvoice', p) //删除发票抬头
apiFun.postUpInvoice = p => post(url + 'BuyerCenter/UpInvoice', p) //编辑发票抬头
apiFun.postInvoiceRequest = p => post(url + 'BuyerCenter/InvoiceRequest', p) //申请开票
apiFun.getModelAgree = p => get(url + 'SellerCenter/ModelAgree', p) //是否应用指导价
apiFun.postupFileDate = p => post(url + 'Platform/upFileDate', p) //修改模型

apiFun.getNotification = p => get(url + 'HomePage/Notification', p) //首次查询通知
apiFun.getUpNotification = p => get(url + 'HomePage/UpNotification', p) //单个通知已读
apiFun.getUpNotifications = p => get(url + 'HomePage/UpNotifications', p) //全部通知已读
apiFun.getDeNotifications = p => get(url + 'HomePage/DeNotifications', p) //全部通知清除

apiFun.postUpModelPrice = p => post(url + 'SellerCenter/UpModelPrice', p) //批量修改模型价格
apiFun.getQueryPhone = p => get(url + 'SellerCenter/queryPhone', p) //查询提现当前手机号
apiFun.getSendCodeV3s = p => get(url + 'SellerCenter/SendCodeV3s', p) //获取验证码
apiFun.getVerificationV3 = p => get(url + 'SellerCenter/verificationV3', p) //校验验证码
apiFun.postVerificationV2 = p => post(url + 'SellerCenter/verificationV2', p) //保存新交易密码

apiFun.getInvoiceDetails = p => get(url + 'BuyerCenter/InvoiceDetail', p) //发票管理列表
apiFun.postUploadInvoice = p => post(url + 'Platform/UploadInvoice', p) //上传PDF/图片文件
apiFun.postSubmission = p => post(url + 'BuyerCenter/Submissions', p) //确认发票信息
apiFun.getModelCombing = p => get(url + 'HomePage/ModelCombing', p) //查询模型数量和模型师数量
apiFun.getOfficialModeler = p => get(url + 'HomePage/OfficialModeler', p) //查询官方模型列表
apiFun.getOfficialModel = p => get(url + 'HomePage/OfficialModel', p) //查询官方特别推荐模型

apiFun.getRelatedModels = p => get(url + 'HomePage/RelatedModels', p) //模型详情页下相关模型推荐
apiFun.getSeInvoice = p => get(url + 'SellerCenter/SeInvoice', p) //查询当前用户能否开票
apiFun.postUpInvoice = p => post(url + 'SellerCenter/UpInvoice', p) //设置/修改当前用户能否开票
apiFun.getSeCertification = p => get(url + 'SellerCenter/SeCertification', p) //查询企业认证
apiFun.postUpCertification = p => post(url + 'SellerCenter/UpCertification', p) //提交企业认证




export default apiFun;